import { auth } from './firebase'
import { sendPasswordResetEmail, signInWithEmailAndPassword, User } from 'firebase/auth'
import { ErrorWithDetails } from "../utility/error-handling/error-handling-utility";
import { useContext } from "react";
import { ShowMessageContext } from "../contexts/ShowMessageContext";

interface LoginData {
  email: string
  password: string
  setFirebaseUser: (user: User) => void
  onSuccess: () => void
  showErrorMessage: (error: any, userFriendlyMessage?: string | undefined) => void
}

export const FirebaseLogin = async (props: LoginData) => {

  const { email, password, setFirebaseUser, onSuccess, showErrorMessage } = props
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password)
    setFirebaseUser(userCredential.user)
    onSuccess()
  }
  catch (error) {
    showErrorMessage(new ErrorWithDetails(error, "logging in"))
  }
}

interface ResetPasswordData {
  email: string
  onSuccess: () => void
}

export const FirebaseResetPassword = async (props: ResetPasswordData) => {
  const { email, onSuccess } = props
  const { showErrorMessage } = useContext(ShowMessageContext)

  try {
    await sendPasswordResetEmail(auth, email)
    onSuccess()
  }
  catch (error) {
    showErrorMessage(new ErrorWithDetails(error, "resetting password"))
  }
}